import { CHART_PLUGINS } from 'sharedComponents/Chart/constants';
import colors from 'theme/_colors.scss';

export const chartPlugins = [
    CHART_PLUGINS.NO_DATA_TO_DISPLAY,
    CHART_PLUGINS.HIGHCHARTS_MORE,
    CHART_PLUGINS.BOOST,
    CHART_PLUGINS.EXPORTING,
    CHART_PLUGINS.OFFLINE_EXPORTING,
    CHART_PLUGINS.STOCK // for Navigator (Timeline Zoom)
];

export const CHART_CONDITION_TREND_KPI_TYPE = 'Kpi';
export const statusBarColors = {
    Poor: colors.pomegranate,
    Tolerable: colors.orangePeel,
    Good: colors.jungleGreen,
    Unknown: colors.neutralGray
};
export const maxAnomalyLevel = 5;


export const coolingAnomalyLevel = 'cooling_anomaly_level';

export const Alignment = {
    LEFT: 'left',
    CENTER: 'center',
    RIGHT: 'right'
};

export const LABEL_EDGE_MARGIN = 10;
export const MIN_LABEL_MAX_WIDTH = 80;
export const CLOSE_LABEL_PIXEL_THRESHOLD = 90;
export const PLOTLINE_DEFAULT_LABEL_Y = 15;
export const PLOTLINE_STACKED_LABEL_Y = 31;

export const PRINT_FONT_FAMILY = 'ABBvoice-Regular';
export const RETRAINING_START_PLOTLINE_ID = 'retraining-start-plotline';
export const RETRAINING_TRIGGERED_PLOTLINE_ID = 'retraining-triggered-plotline';
export const RETRAINING_COMPLETED_PLOTLINE_ID = 'retraining-completed-plotline';
